import { render, staticRenderFns } from "./RetrCurrentManufacturerRow.vue?vue&type=template&id=4459a066"
import script from "./RetrCurrentManufacturerRow.vue?vue&type=script&lang=js"
export * from "./RetrCurrentManufacturerRow.vue?vue&type=script&lang=js"
import style0 from "./RetrCurrentManufacturerRow.vue?vue&type=style&index=0&id=4459a066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports